import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class OrganizationTypeService  {
  organizationTypes: any[];
  onOrganizationTypeChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getOrganizationTypes()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getOrganizationTypes () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/organizationType/organizationTypes'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.organizationTypes = response;
          this.onOrganizationTypeChanged.next(this.organizationTypes);
          resolve(response);
        }, reject);
    });

  }

  getOrganizationById(id) {
    return this.http.get(this.api.baseUrl + '/organizationType/organizationType?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteOrganizationType(id) {
    return this.http.delete(this.api.baseUrl + '/organizationType/deleteOrganizationType?id=' + id , this.api.jsonTokenHeaders);
  }

  addOrganizationType(data) {
    return this.http.post(this.api.baseUrl + '/organizationType/addOrganization' , data , this.api.formDataHeaders);
  }
}
